import { z } from 'zod';
import type { HttpClient } from '@wix/cli-http-client';
import type { ComponentGenerationResult } from '@wix/gena';
import type { ProjectModel } from '../../../model.js';

type ExtensionGroup = 'Dashboard' | 'Backend' | 'Site';

interface ExtensionGenerate<T extends z.ZodTypeAny = z.ZodTypeAny> {
  projectFolder: string;
  appId: string;
  model: ProjectModel;
  data: z.infer<T>;
  httpClient: HttpClient;
}

export interface ExtensionDef<T extends z.ZodTypeAny = z.ZodTypeAny> {
  title: string;
  description?: string;
  group: ExtensionGroup;
  documentation?: string;
  zodSchema:
    | z.ZodTypeAny
    | ((httpClient: HttpClient) => z.ZodTypeAny | Promise<z.ZodTypeAny>);
  generate: (
    options: ExtensionGenerate<T>
  ) => Promise<ComponentGenerationResult | void>;
  validate?: (
    projectFolder: string,
    data: z.infer<T>
  ) => Promise<string | null>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyExtensionDef = ExtensionDef<any>;

export const extensionFieldDefinitionSchema = z.object({
  title: z.string(),
  description: z.string().optional(),
});

export type ExtensionFieldDefinition = z.infer<
  typeof extensionFieldDefinitionSchema
>;

export const extensionTypeSchema = z.object({
  extensionType: z.string(),
});
